
export enum TypeTwoFa {
  NONE = 'NONE',
  EMAIL = 'EMAIL',
  APP = 'APP',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  TELEGRAM = 'TELEGRAM'
}
